import { render, staticRenderFns } from "./SidePanelNewNeeds.vue?vue&type=template&id=a5089ff0&scoped=true&"
import script from "./SidePanelNewNeeds.vue?vue&type=script&lang=js&"
export * from "./SidePanelNewNeeds.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNewNeeds.vue?vue&type=style&index=0&id=a5089ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5089ff0",
  null
  
)

export default component.exports